// extracted by mini-css-extract-plugin
module.exports =  {"button":"_25d45facb5--button--O41Oz"};